export default "__VITE_ASSET__65d52310__"